import { LIB_UI_POST_PIN_FAILURE, LIB_UI_POST_PIN_REQUEST, LIB_UI_POST_PIN_SUCCESS } from 'actions/pin/postPin.action';
import { AT_LOGOUT_SUCCESS } from 'utils/cognito.util';
import alwaysSame from 'utils/functions/nullary/alwaysSame.util';

import { SALON_DETAILS_SUCCESS } from 'lib/constants/currentSalon';
import { LIB_UI_ACTIVITY_DETECTED, LIB_UI_CLEAR_LOCK_ERROR, LIB_UI_SET_LOCK, PUSH_PIN_SETTINGS_CHANGE } from 'lib/constants/libConstants';
import determineData from 'lib/reducers/determineData';
import determineState from 'lib/reducers/determineState';
import reduceClearLockError from 'lib/reducers/reduceClearLockError';
import reduceDetectedUiActivity from 'lib/reducers/reduceDetectedUiActivity';
import reduceLibStateReset from 'lib/reducers/reduceLibStateReset';
import reducePinFailure from 'lib/reducers/reducePinFailure';
import reducePinRequest from 'lib/reducers/reducePinRequest';
import reducePinSuccess from 'lib/reducers/reducePinSuccess';
import reducePushPinSettings from 'lib/reducers/reducePushPinSettings';
import reduceSalons from 'lib/reducers/reduceSalons';
import reduceThresholdAndLockSetting from 'lib/reducers/reduceThresholdAndLockSetting';
import reduceUiLockUpdate from 'lib/reducers/reduceUiLockUpdate';
import { SALONSBYUSER_SUCCESS } from 'salon/constants';

// this removes the switch/case noise
const MAP = Object.freeze({
  [LIB_UI_ACTIVITY_DETECTED]: reduceDetectedUiActivity,
  [LIB_UI_SET_LOCK]: reduceUiLockUpdate,
  [LIB_UI_CLEAR_LOCK_ERROR]: reduceClearLockError,
  [LIB_UI_POST_PIN_REQUEST]: reducePinRequest,
  [LIB_UI_POST_PIN_FAILURE]: reducePinFailure,
  [LIB_UI_POST_PIN_SUCCESS]: reducePinSuccess,
  [SALON_DETAILS_SUCCESS]: reduceThresholdAndLockSetting,
  [PUSH_PIN_SETTINGS_CHANGE]: reducePushPinSettings,
  [SALONSBYUSER_SUCCESS]: reduceSalons,
  [AT_LOGOUT_SUCCESS]: reduceLibStateReset,
});

// this top level reducer serves to set up defaults for the state, if needed, as deep as necessary
// determine the action data from variety of different action shapes
// and delegate to the specific handlers per the action type
const libReducer = (state, action) => (MAP[(action && action.type) || ''] || alwaysSame)(determineState(state), determineData(action));

export default libReducer;
